import { render, staticRenderFns } from "./CMSCustomFieldList.vue?vue&type=template&id=5387ed50&"
import script from "./CMSCustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CMSCustomFieldList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports